import { Component, OnInit } from '@angular/core';
import {BehaviorSubject} from 'rxjs';
import {MatSnackBar} from '@angular/material/snack-bar';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {MatDialog} from '@angular/material/dialog';
import {DialogErrorComponent} from '../../dialogs/dialog-error/dialog-error.component';
import {VultrInstance} from '../../models/vultr-instance';
import {VultrSnapshot} from '../../models/vultr-snapshot';
import {VultrService} from '../../services/vultr-service';

@Component({
  selector: 'app-vultr',
  templateUrl: './vultr.component.html',
  styleUrls: ['./vultr.component.scss']
})
export class VultrComponent implements OnInit {

    loadingSnapshots$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(true);
    loadingInstances$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(true);
    hasInstances$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
    hasSnapshots$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
    snapshots$: BehaviorSubject<VultrSnapshot[]> = new BehaviorSubject<VultrSnapshot[]>([]);
    instances$: BehaviorSubject<VultrInstance[]> = new BehaviorSubject<VultrInstance[]>([]);

    smsForm: FormGroup;


  constructor(
      private vultrService: VultrService,
      private formBuilder: FormBuilder,
      public snackBar: MatSnackBar,
      private dialog: MatDialog
  ) { }

  ngOnInit(): void {
      this.createForm();
      this.getSnapshots();
      this.getInstances();
  }

    createForm() {
        this.smsForm = this.formBuilder.group({
            originator: ['StreamUp', [Validators.required, Validators.maxLength(11)]],
            recipients: ['',  [Validators.required, Validators.pattern('[,0-9]*')]],
            message: ['', Validators.required],
            flash: [false]
        });
    }

    get f(){
        return this.smsForm.controls;
    }

    createSnapshot(instance: VultrInstance): void {
      this.vultrService.createSnapshot(instance.id, 'test')
          .subscribe((response: any) => {
              if (!response.error){
                  this.snackBar.open('Command successful', null, {duration: 1000});
                  this.loadingSnapshots$.next(true);
                  setTimeout(() => {
                      this.getSnapshots();
                  }, 3000);
              }else{
                  this.snackBar.open(response.message.information, null, {duration: 3000});
              }
          }, (errorResponse: any) => {
              this.handleError(errorResponse.error.message.information);
          });
  }

  getInstances(){
      this.loadingInstances$.next(true);
      this.vultrService.getInstances()
          .subscribe((instances: VultrInstance[]) => {
              this.instances$.next(instances);
              this.hasInstances$.next(instances.length > 0);
              this.loadingInstances$.next(false);
          });
  }

    getSnapshots(){
      this.loadingSnapshots$.next(true);
      this.vultrService.getSnapshots()
          .subscribe((snapshots: VultrSnapshot[]) => {
              this.snapshots$.next(snapshots);
              this.hasSnapshots$.next(snapshots.length > 0);
              this.loadingSnapshots$.next(false);
          });
    }

    // showPredefinedSms(){
    //     return this.dialog
    //         .open(DialogPredefinedSmsComponent, {
    //             width: '600px',
    //             role: 'dialog'
    //         })
    //         .afterClosed()
    //         .subscribe(body => {
    //             if (body != null) {
    //                 this.smsForm.controls.message.patchValue(body);
    //             }
    //         });
    // }

    handleError(errorInformation: string){
        return this.dialog
            .open(DialogErrorComponent, {
                data: {
                    error: errorInformation,
                },
                width: '600px',
                role: 'dialog'
            })
            .afterClosed()
            .subscribe();
    }

    resetForm(){
      this.smsForm.reset();
    }

}
